<div id="AbpContentToolbar"></div>
<div class="card border-0 shadow-sm min-h-400">
  <div class="card-body">
    <div class="row">
      <div class="col-12 col-md-3">
        <ul class="nav flex-column nav-pills" id="nav-tab" role="tablist">
          <li class="nav-item mb-2" (click)="selectedTab = 0">
            <a
              class="nav-link"
              [ngClass]="{ active: selectedTab === 0 }"
              role="tab"
              href="javascript:void(0)"
              >{{ 'AbpAccount::PersonalSettings' | abpLocalization }}</a
              >
            </li>
            <li
              *abpPermission="'ReturnLy.Account.ChangePassword'"
              class="nav-item mb-2"
              (click)="selectedTab = 1"
              >
              <a
                class="nav-link"
                [ngClass]="{ active: selectedTab === 1 }"
                role="tab"
                href="javascript:void(0)"
                >{{ 'AbpUi::ChangePassword' | abpLocalization }}</a
                >
              </li>
              <li
                class="nav-item mb-2"
                (click)="selectedTab = 2"
                >
                <a
                  class="nav-link"
                  [ngClass]="{ active: selectedTab === 2 }"
                  role="tab"
                  href="javascript:void(0)"
                  >{{ '::PaymentTab' | abpLocalization }}</a
                  >
                </li>
                <li
                  *abpPermission="'ReturnLy.Addresses'"
                  class="nav-item mb-2"
                  (click)="selectedTab = 3"
                  >
                  <a
                    class="nav-link"
                    [ngClass]="{ active: selectedTab === 3 }"
                    role="tab"
                    href="javascript:void(0)"
                    >{{ '::AddressTab' | abpLocalization }}</a
                    >
                  </li>
                  <li
                    *abpPermission="'ReturnLy.Settings'"
                    class="nav-item mb-2"
                    (click)="selectedTab = 4"
                    >
                    <a
                      class="nav-link"
                      [ngClass]="{ active: selectedTab === 4 }"
                      role="tab"
                      href="javascript:void(0)"
                      >{{ '::AccountSettings' | abpLocalization }}</a
                      >
                    </li>
                  </ul>
                </div>
                <div class="col-12 col-md-9">
                  @if (selectedTab === 0) {
                    <div class="tab-content">
                      <div class="tab-pane active" role="tabpanel">
                        <app-profile-tab></app-profile-tab>
                      </div>
                    </div>
                  }
                  <div
                    *abpPermission="'ReturnLy.Account.ChangePassword'"
                    class="tab-content"
                    [hidden]="selectedTab !== 1"
                    >
                    <div class="tab-pane active" role="tabpanel">
                      <h4>
                        {{ 'AbpIdentity::ChangePassword' | abpLocalization }}
                        <hr />
                      </h4>
                      <abp-change-password-form></abp-change-password-form>
                    </div>
                  </div>
                  <div
                    class="tab-content"
                    [hidden]="selectedTab !== 2"
                    >
                    <div class="tab-pane active" role="tabpanel">
                      <app-payment-tab></app-payment-tab>
                    </div>
                  </div>
                  <div
                    *abpPermission="'ReturnLy.Addresses'"
                    class="tab-content"
                    [hidden]="selectedTab !== 3"
                    >
                    <div class="tab-pane active" role="tabpanel">
                      <app-addresses-tab></app-addresses-tab>
                    </div>
                  </div>
                  <div
                    *abpPermission="'ReturnLy.Settings'"
                    class="tab-content"
                    [hidden]="selectedTab !== 4"
                    >
                    <div class="tab-pane active" role="tabpanel">
                      <app-settings-tab></app-settings-tab>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
